import { CellAttributes } from './cell-attributes';

export class ColumnText {
	public static create(options: ColumnTextOptions): ColumnText {
		return new ColumnText(options.key, options.defaultText, options.translated, options.attributes);
	}

	constructor(public readonly key: string, public readonly defaultText: string = null, public translated?: string, public readonly attributes: CellAttributes = {}) { }

	public toString(): string {
		return this.translated || this.defaultText;
	}
}

export interface ColumnTextOptions {
	key: string;
	defaultText: string;
	translated: string;
	attributes: CellAttributes;
}
